"use client";

import { useCallback } from "react";
import Accordion, { FAQ } from "~/componentsDS/Accordion";
import Container from "~/componentsDS/Layout/Container";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Overline from "~/componentsDS/Typography/Overline";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { faqPqpList, faqPqpSafetyList } from "~/data/faq";
import { useTrackEvent } from "~/hooks/useTrackEvent";
import { getTextFromNode } from "~/utils/getTextFromNode";

const FAQSection = () => {
    const sendEvent = useTrackEvent();

    const handleFaqOpen = useCallback((item: FAQ) => {
        sendEvent({
            event: "user_interaction",
            value: {
                event_name: GTM_EVENT_NAMES.PDP_INTERACTION,
                widget: "pdp_faqs",
                meta_data: {
                    click_text: getTextFromNode(item.question),
                },
            },
        });
    }, [sendEvent]);

    return (
        <section className="relative py-16 md:py-[96px] -mt-4 bg-primary100 text-primary500 rounded-t-2xl z-[1]">
            <Container>
                <div className="flex flex-col lg:flex-row lg:justify-between gap-6 lg:gap-[90px]">
                    <div className="md:w-[310px] lg:w-[435px]">
                        <Reveal>
                            <Heading as="h2" className="tracking-[-1.2px] whitespace-nowrap max-md:text-center">
                                Questions?
                            </Heading>
                        </Reveal>
                    </div>
                    <div className="w-full md:max-w-[950px]">
                        <Overline weight="500" className="text-primary300 mb-4 max-md:text-center">Getting Started</Overline>
                        <Accordion
                            items={faqPqpList}
                            onOpen={handleFaqOpen}
                        />

                        <Overline weight="500" className="text-primary300 mt-10 md:mt-8 mb-4 max-md:text-center">Safety & Ingredients</Overline>
                        <Accordion
                            items={faqPqpSafetyList}
                            onOpen={handleFaqOpen}
                        />
                    </div>
                </div>
            </Container>
        </section>
    )
};

export default FAQSection;
